import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { css } from "emotion";
import defaultTo from "lodash/defaultTo";
import {
  Button,
  Form,
  Grid,
  TextArea,
  Divider,
  Icon,
  Accordion
} from "semantic-ui-react";
import DateSelector from "../custom/DateSelector";
import DisplayField from "../custom/DisplayField";
import "./footer.css";
import CompactGrid from "../custom/CompactGrid";
import POIdentifierModal from "./POIdentifierModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

function TopPanel({
  isNewWorksheet,
  enableSave,
  worksheetName,
  department,
  vendor,
  departments,
  vendors,
  isSaving,
  isCdpIntiate,
  onClickSave,
  onClickVendorCommitment,
  onClickCreateOrder,
  onChangeWorksheetName,
  onChangeDepartment,
  onChangeVendor,
  onChangeTicketType,
  ticketType,
  ticketTypeValue,
  onChangeDate,
  onChangePurchaseOrderNumber,
  handleDateChange,
  onChangePurchaseOrderDescription,
  onChangeVendorNotes,
  onClickAddNewRow,
  onToggleViewDetail,
  showDetailView,
  vendorNotes,
  purchaseOrderNumber,
  purchaseOrderDescription,
  MaycsNetRouteDate,
  CancelDate,
  cdpCalenderVal,
  sellingDiv,
  buyingDiv,
  IndcDate,
  DistroByDate,
  inputErrors,
  disablePurchaseOrderNumber,
  isVendorUpcMode,
  onChangeVendorUPC,
  POIdentifiers,
  onPOIdentifierChange,
  isCdpProduct,
  isDisabled, 
  orderStatus,
  ...props
}) {
  return (
    <Fragment>
      <CompactGrid padded="vertically">
        <Grid.Row>
          <Grid.Column width={13}>
            <Form className={cdpTopPanel} size="small">
              <Form.Group>
                <Form.Input
                  width={4}
                  label="Work Sheet Name "
                  value={worksheetName}
                  onInput={onChangeWorksheetName}
                />
                <Form.Select
                  label="Department "
                  search
                  options={defaultIds(departments)}
                  onChange={onChangeDepartment}
                  value={department}
                  style={ { pointerEvents: isDisabled ? 'none' : '', opacity:  isDisabled ? '.9' : ''} } 
                />
                <Form.Select
                  label="Vendor "
                  search
                  options={defaultIds(vendors)}
                  onChange={onChangeVendor}
                  value={vendor}
                  style={ { pointerEvents: isDisabled ? 'none' : '', opacity:  isDisabled ? '.9' : ''} } 
                />
                { isCdpProduct == 'false' ?<Form.Checkbox
                  label="Vendor UPC"
                  checked={isVendorUpcMode}
                  onChange={onChangeVendorUPC}
                  style={ { pointerEvents: isDisabled ? 'none' : '', opacity:  isDisabled ? '.9' : '', marginTop: 30} } 
                />: null }
                { isCdpProduct != 'false' ?
                  <Grid.Column>
                    <label className="cdp-input-label">CDP Month</label>
                    <br/>
                    <DatePicker
                      showMonthYearPicker
                      dateFormat="MM/yy"
                      onChange={handleDateChange }
                      selected={cdpCalenderVal}
                      className="date-picker-input"
                      onKeyDown={(e) => {
                        if (!_.includes([8, 17, 37, 39], e.keyCode) && !e.ctrlKey) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Grid.Column> : null }
              </Form.Group>
              
            </Form>
          </Grid.Column>
          { props.productDetailsOpener == "Home" ?
          <Grid.Column width={3} verticalAlign="bottom">
          <Button icon labelPosition='left'>
                        <Link to={`/home`}>Back to Search </Link>
                        <Icon name='left arrow' />
                    </Button>
          </Grid.Column>: undefined 
          }
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Accordion className={POTitleStyle}>
              { isCdpProduct != 'false' ? 
                <Accordion.Title
                  active={showDetailView}
                  onClick={onToggleViewDetail}
                >
                  <Icon name="dropdown" /> PO Header  <b className={'label-selling-div'}>Selling Div</b>: {sellingDiv}
                  <b className={'label-buying-div'}>Buying Div</b>: {buyingDiv}
                </Accordion.Title>
                :
                <Accordion.Title
                  active={showDetailView}
                  onClick={onToggleViewDetail}
                >
                  <Icon name="dropdown" /> PO Header &nbsp; &nbsp; &nbsp; {purchaseOrderNumber? 'PO #':''}  {purchaseOrderNumber} &nbsp; &nbsp; 
                  {isDisabled?
                  <span style={{backgroundColor: 'pink', color:'red'}}>&nbsp; &nbsp; {orderStatus} &nbsp; &nbsp; </span>
                  :
                  <span>&nbsp; &nbsp; {orderStatus} &nbsp; &nbsp; </span>
                  }
                </Accordion.Title> 
              }
              <Accordion.Content active={showDetailView}>
                <Form size="small" className={POHeaderStyle}>
                  <div className="column">   
                      {(disablePurchaseOrderNumber && isCdpProduct == 'false') ? (
                        <div className="field">
                          <label>PO#</label>
                          <div className={'poInput'}>
                            {purchaseOrderNumber}
                          </div>
                        </div>
                      ) : (
                        <Form.Input
                          label="PO#"
                          error={inputErrors["DistroByDate"]}
                          value={purchaseOrderNumber}
                          onChange={onChangePurchaseOrderNumber}
                        />
                      )}
                    <Form.Input
                      label="PO Desc"
                      value={purchaseOrderDescription}
                      onChange={onChangePurchaseOrderDescription}
                      maxLength={30} 
                      style={ { pointerEvents: isDisabled ? 'none' : '', opacity:  isDisabled ? '.9' : ''} }
                    />

                    <Form.Select
                      error={inputErrors["TicketType"]}
                      onChange={onChangeTicketType}
                      value={ticketTypeValue}
                      label="Ticket Type"
                      options={defaultIds(ticketType)}
                      style={ { pointerEvents: isDisabled ? 'none' : '', opacity:  isDisabled ? '.9' : ''} }
                    />
                  </div>

                  <div className="column">
                    <DateSelector
                      error={inputErrors["IndcDate"]}
                      label="In DC Date"
                      selected={IndcDate}
                      onChange={onChangeDate("IndcDate")}
                      disabled={isDisabled || isCdpProduct != 'false'}
                    />
                    <DateSelector
                      error={inputErrors["CancelDate"]}
                      label="Cancel Date"
                      selected={CancelDate}
                      onChange={onChangeDate("CancelDate")}
                      disabled={isDisabled || isCdpProduct != 'false'}
                    />
                    <DateSelector
                      error={inputErrors["DistroByDate"]}
                      label="Distro By Date"
                      selected={DistroByDate}
                      onChange={onChangeDate("DistroByDate")}
                      disabled={isDisabled || isCdpProduct != 'false'}
                    />
                    { isCdpProduct == 'false' ?
                      <DateSelector
                        error={inputErrors["MaycsNetRouteDate"]}
                        label="MacysNet Route Date"
                        selected={MaycsNetRouteDate}
                        onChange={onChangeDate("MaycsNetRouteDate")}
                        disabled={isDisabled}
                      /> : null }
                  </div>

                  { isCdpProduct == 'false' ? 
                    <div className="column">
                      <Form.Field style={ { pointerEvents: isDisabled ? 'none' : '', opacity:  isDisabled ? '.9' : ''} }>
                        <label>Vendor Notes</label>
                        <TextArea
                          error={inputErrors["DistroByDate"]}
                          placeholder="Tell us more"
                          value={vendorNotes}
                          onChange={onChangeVendorNotes}
                           
                        />
                      </Form.Field>

                      <Form.Field>
                        {isNewWorksheet ? null : (
                          <POIdentifierModal
                            IndcDate={IndcDate}
                            POIdentifiers={POIdentifiers}
                            onPOIdentifierChange={onPOIdentifierChange}
                          />
                        )}
                      </Form.Field>
                    </div> : null }

                  <div className="column grow" />
                </Form>
              </Accordion.Content>
            </Accordion>
            <Divider />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Button onClick={onClickAddNewRow} icon="plus" disabled={isDisabled}/>
            
            <Button
              primary
              onClick={onClickSave}
              disabled={!enableSave || isSaving}
              loading={isSaving}
            >
              Save
            </Button>
            {(!isNewWorksheet && isCdpProduct == 'false') && (
              <React.Fragment>
                <Button onClick={onClickVendorCommitment} disabled={isSaving}>
                  Vendor Commitment
                </Button>
                { orderStatus == 'PO can be updated' || orderStatus == 'Not allocated'?
                  <Button onClick={onClickCreateOrder} disabled={isSaving}>
                  Process Updates
                </Button>
                :
                <Button onClick={onClickCreateOrder} disabled={isSaving}>
                  Create Items and Order
                </Button>
                }
              </React.Fragment>
            )}
            { isCdpProduct == 'true' ? 
                <Button disabled={isCdpIntiate} >
                  CDP Initiate
                </Button>: null}
          </Grid.Column>
        </Grid.Row>
      </CompactGrid>
    </Fragment>
  );
}

TopPanel.propTypes = {
  worksheetName: PropTypes.string,
  department: PropTypes.any,
  vendor: PropTypes.any,
  departments: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.any
    })
  ),
  preTicket: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.any
    })
  ),
  vendors: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.any
    })
  ),
  onClickSave: PropTypes.func,
  onClickVendorCommitment: PropTypes.func,
  onClickCreateOrder: PropTypes.func,
  onChangeWorksheetName: PropTypes.func,
  onChangeDepartment: PropTypes.func,
  onChangeVendor: PropTypes.func,
  purchaseOrderNumber: PropTypes.string,
  purchaseOrderDescription: PropTypes.string,
  vendorNotes: PropTypes.string,
  preTicketValue: PropTypes.string,
  onChangeDate: PropTypes.func,
  onChangePurchaseOrderNumber: PropTypes.func,
  handleDateChange: PropTypes.func,
  onChangePurchaseOrderDescription: PropTypes.func,
  onChangeVendorNotes: PropTypes.func,
  onToggleViewDetail: PropTypes.func,
  showDetailView: PropTypes.bool.isRequired,
  ticketType: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.any
    })
  ),
  onChangeTicketType: PropTypes.func,
  ticketTypeValue: PropTypes.number
};

function defaultIds(list) {
  return list.map(({ text, title, value }) => ({
    text,
    title,
    value: defaultTo(value, -1)
  }));
}

const POHeaderStyle = css`
  & {
    display: flex;
    flex-direction: row;

    .column {
      flex: 1;
      padding: 5px;

      .grow {
        flex: grow;
      }
    }

    .poInput{
      line-height: 1.21428571em;
      padding: .67857143em 1em;
      font-size: 1em;
      background: #fff;
      border: 1px solid rgba(34,36,38,.15);
      color: rgba(0,0,0,.87);
      border-radius: .28571429rem;
      opacity: 0.9;
      width: 200px;
    }

    .poInput::selection { 
      background: #c1c1c1;
    }
    .field {
      display: flex;
      justify-content: flex-end;
    }

    .input,
    .selection.dropdown,
    textarea {
      width: 200px !important;
      margin: 0px;
    }

    .input {
      padding: 0px;
    }

    .input > input {
      width: 100% !important;
    }
    
    label {
      display: inline-block !important;
      margin-right: 5px !important;
      white-space: nowrap;
    }

    .isDisabled {
      opacity: .9
    }
    
  }
`;

const POTitleStyle = css`
  & {
      .label-selling-div {
        margin-left: 90px;
      }
      .label-buying-div {
        margin-left: 30px;
      }
    }
  `;

const cdpTopPanel = css`
  & {
      .cdp-input-label {
        font-size: .92857143em;
        font-weight: 700;
        margin-left:10px;
      }
      .date-picker-input {
        margin-top: 4px !important;
        margin-left: 10px !important;
        width: 85px !important;
      }
  }
`;

const mapStateToProps = (reduxState) => {
  return { productDetailsOpener: reduxState.productDetailsOpener}
}

export default connect(mapStateToProps)(TopPanel);



// WEBPACK FOOTER //
// ./components/product-detail/TopPanel.js